import { Select, MenuItem, TextField } from '@mui/material';

/**
 * Type-aware value input.
 * MUST be defined at module level (not inside another component) so React
 * never recreates the component type on re-render — that would lose focus.
 */
const ValueInput = ({ fieldType, val, onChange, placeholder, fullWidth }) => {
  if (fieldType === 'date') {
    return (
      <TextField
        type="date"
        size="small"
        value={val}
        onChange={e => onChange(e.target.value)}
        fullWidth={fullWidth}
        sx={{
          width: fullWidth ? undefined : 150,
          '& input::-webkit-calendar-picker-indicator': {
            filter: 'invert(1)',
            opacity: 0.75,
            cursor: 'pointer',
          },
        }}
        slotProps={{ inputLabel: { shrink: true } }}
      />
    );
  }

  if (fieldType === 'boolean') {
    return (
      <Select
        size="small"
        value={val}
        onChange={e => onChange(e.target.value)}
        fullWidth={fullWidth}
        sx={{ minWidth: fullWidth ? undefined : 90 }}
      >
        <MenuItem value="true">true</MenuItem>
        <MenuItem value="false">false</MenuItem>
      </Select>
    );
  }

  return (
    <TextField
      size="small"
      type={fieldType === 'number' ? 'number' : 'text'}
      value={val}
      placeholder={placeholder}
      onChange={e => onChange(e.target.value)}
      fullWidth={fullWidth}
      sx={{ width: fullWidth ? undefined : (fieldType === 'number' ? 100 : 160) }}
    />
  );
};

export default ValueInput;
